<template>
    <activation-preview-provider
        v-slot="{
            brief,
            step,
        }"
        :module-name="moduleName"
    >
        <activation-brief-assets-view
            v-if="brief"
            :brief="brief"
            :step="step"
            :is-preview="true"
        />
        <g-loader v-else type="fixed" />
    </activation-preview-provider>
</template>

<script>
    import ActivationPreviewProvider from '../../providers/preview-providers/ActivationPreviewProvider';
    import ActivationBriefAssetsView from '../../data-views/activation-briefs/ActivationBriefAssetsView';
    import PageMask from '../../library/PageMask';
    import {NAME_BRAND_ASSETS} from '../../../constants/activation-brief-steps';

    export default {
        name:       'ActivationAssetsPreviewRouterView',
        components: {
            ActivationBriefAssetsView,
            ActivationPreviewProvider,
            PageMask,
        },
        data(){
            return {
                moduleName: NAME_BRAND_ASSETS,
            };
        },
    };
</script>
